import React from "react";
export default class ContactSection extends React.Component {
  constructor() {
    super();
    this.state = {
      formSubmitMessage: false
    };
  }
  handleFormSubmission(e) {
    e.preventDefault();
    this.setState({
      formSubmitMessage: !this.state.formSubmitMessage
    });
    const form = document.getElementById("contactFormId");
    form.reset();
  }
  render() {
    return (
      <section id="contact-section" className="contact-section   text-center">
        <div className="fullwidth section">
          <div className="container">
            <h2>
              <span className="red">How</span> to find us
            </h2>
            <p>
              Contact us if you have any question regarding to our products and
              services.
            </p>
          </div>
        </div>
        <div className="mapsection fullwidth">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5571.658264089234!2d151.05471555449677!3d-33.86575089458592!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12bb44f88b380b%3A0x756b36b2b94a0acd!2sCP+Food+Service!5e0!3m2!1sen!2sin!4v1554188063888!5m2!1sen!2sin"></iframe>
        </div>
        <div className="fullwidth section address-wrapper" id="contact-us">
          <div className="container">
            <div className="row text-left">
              <div className="col-sm-4 col-12">
                <div className="address-section">
                  <div className="address">
                    <h5>
                      <strong>Address</strong>
                    </h5>
                    <p>
                      36/159 Arthur Street,
                      <br />
                      Homebush West NSW 2140
                      <br />
                      Australia
                    </p>
                  </div>
                  <div className="call us">
                    <h5>
                      <strong>Call Us</strong>
                    </h5>
                    <p>
                      <a href="tel:0287460633">(02)8746 0633</a>
                    </p>
                  </div>
                  <div className="call us">
                    <h5>
                      <strong>Mail Us</strong>
                    </h5>
                    <p>
                      <a href="mailto:info@cpfoodservices.com.au">
                        info@cpfoodservice.com.au
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-8 col-12">
                <form
                  id="contactFormId"
                  name="contactForm"
                  onSubmit={e => this.handleFormSubmission(e)}
                >
                  <div className="row">
                    <div className="col-sm-6 col-12 form-group">
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Your Name"
                        required
                      />
                    </div>
                    <div className="col-sm-6 col-12 form-group">
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Your Email"
                        required
                      />
                    </div>
                    <div className="col-sm-6 col-12 form-group">
                      <input
                        type="text"
                        name="subject"
                        className="form-control"
                        placeholder="Subject"
                        required
                      />
                    </div>
                    <div className="col-sm-6 col-12 form-group">
                      <input
                        type="text"
                        name="contact"
                        className="form-control"
                        placeholder="Contact Number"
                        required
                      />
                    </div>
                    <div className="col-sm-12 col-12 form-group">
                      <textarea
                        placeholder="Message"
                        className="form-control"
                        name="message"
                      ></textarea>
                    </div>
                    <div className="col-sm-12 col-12 text-center">
                      {this.state.formSubmitMessage && (
                        <div className="form-message">
                          Thank you for your enquiry, we endeavour to get back
                          to you within 48 hours. For urgent matters, please
                          contact us directly on (02) 8746 0633
                        </div>
                      )}
                      <input
                        type="submit"
                        name="submit"
                        className="btn submit-btn"
                        value="Submit"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home/Contact-Section.js